<template>
  <div class="dev-personas q-gutter-md">
    <q-select
      ref="devPersonasSelect"
      v-model="selectedPersona"
      use-input
      hide-selected
      fill-input
      dense
      bg-color="light"
      :options
      @filter="filterFn"
      @update:model-value="onSelect"
    />
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'

import { useConfig } from '@/composables/useConfig'
import { useCurUser } from '@/composables/useCurUser'

const config = useConfig()
const { username } = useCurUser()
const router = useRouter()

const devPersonasSelect = ref()

const staticPersonas = Object.keys(config.DEV_PERSONAS)
const options = ref(staticPersonas)
const selectedPersona = ref(staticPersonas.includes(username.value) ? username.value : null)

function filterFn(val, update) {
  update(() => {
    if (!val || val === '') {
      options.value = staticPersonas

      return
    }

    const needle = val.toLowerCase()
    options.value = staticPersonas.filter(v => v.toLowerCase().includes(needle))
  })
}

function onSelect(value) {
  router.push({ name: 'impersonateLogin', query: { persona: value } })
}

onMounted(async () => {
  setTimeout(() => {
    if (devPersonasSelect.value) {
      devPersonasSelect.value.showPopup()
    }
  }, 300)
})
</script>

<style lang="scss" scoped>
.dev-personas {
  :deep(.q-field--standard.q-field--dense .q-field__control) {
    padding: 0 12px;
  }
}
</style>
